import { EmptyState, Spinner, Text } from '@/shared/ui';
import { HotelResultCard } from './hotel-result-card';
import css from './hyperguest-search.module.scss';

type Props = {
  results: unknown[] | undefined;
  loading: boolean;
  error: string | null;
};

export const ResultsGrid = ({ results, loading, error }: Props) => {
  if (loading)
    return (
      <div className={css.loading}>
        <Spinner />
      </div>
    );
  if (error)
    return (
      <Text size="sm" variant="error">
        {error}
      </Text>
    );
  if (!results)
    return (
      <EmptyState
        title="No search yet"
        description="Pick hotels above and hit Search."
      />
    );
  if (results.length === 0)
    return (
      <EmptyState
        title="No availability"
        description="HyperGuest returned no results for your criteria."
      />
    );

  return (
    <div className={css.resultsGrid}>
      {results.map((r, i) => (
        <HotelResultCard key={i} result={r} />
      ))}
    </div>
  );
};
